import { useState, memo } from "react";
import "../completed-services/CompletedServices.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsAuth } from "../../../redux/slices/auth";
import arrowImage from "../../../assets/arrow-small.png";
import { months } from "../../../data";
import ChangeOrder from "./ChangeOrder";
import CancelOrder from "./CancelOrder";
import { Calendar } from "react-multi-date-picker";

const MyOrders = memo(() => {
  const [modal, setModal] = useState(false);
  const [dataChange, setDataChange] = useState(null);
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelId, setCancelId] = useState(false);

  const handleOpenModal = (value, data = null) => {
    setModal(value);
    setDataChange(data);
  };

  const handleCancelOrder = value => {
    setCancelId(value);
    setCancelModal(true);
  };

  const handleCloseModal = () => {
    handleOpenModal(false);
  };

  const dispatch = useDispatch();
  const isAuth = useSelector(selectIsAuth);
  const { order } = useSelector(state => state.order);

  const [expandedItems, setExpandedItems] = useState([]);

  const toggleExpand = index => {
    setExpandedItems(prevExpanded => {
      if (prevExpanded.includes(index)) {
        return prevExpanded.filter(itemIndex => itemIndex !== index);
      } else {
        return [...prevExpanded, index];
      }
    });
  };

  const [markedDates, setMarkedDates] = useState([]);

  // Функция для извлечения будущих дат уборок
  useEffect(() => {
    const futureDates = order.items
      .filter(item => {
        // Фильтрация объектов: оставляем только будущие даты и не отмененные заказы
        const itemDate = new Date(item.date);
        return itemDate > new Date() && !item.isCanceled;
      })
      .map(item => new Date(item.date));

    setMarkedDates(futureDates);
  }, [order.items]);

  return (
    <section>
      <ul className="completed-services__items">
        {order.items.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              fontSize: "22px",
              color: "#b2b2b2",
              padding: "32px 0",
            }}>
            У вас нет заказов
          </div>
        ) : (
          order.items
            .slice()
            .reverse()
            .filter(item => {
              // Фильтрация объектов по условиям
              if (item.isCanceled || item.state) {
                return false;
              }
              if (!item.isPaid && item.payment_type === "Безналичный расчет") {
                return false;
              }
              return true; // Показывать только допустимые объекты
            })
            .map((item, index) => {
              const isExpanded = expandedItems.includes(index);
              const date = new Date(item.date);
              const day = date.getDate();
              const month = months[date.getMonth()];
              const hours = date.getHours();
              const minutes = date.getMinutes().toString().padStart(2, "0");

              return (
                <li
                  className={`completed-services__item completed-services__item-order ${
                    isExpanded ? "expanded" : ""
                  }`}
                  key={index}>
                  <div className="completed-services__item-header">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        onClick={() => toggleExpand(index)}
                        className="completed-services__arrow">
                        {!isExpanded ? (
                          <img src={arrowImage} width={18} alt="" />
                        ) : (
                          <img
                            src={arrowImage}
                            width={18}
                            alt=""
                            style={{ transform: "rotate(180deg)" }}
                          />
                        )}
                      </span>
                      <div
                        className="completed-services__text"
                        style={{ display: "flex", marginLeft: "8px" }}>
                        {item.group}
                      </div>
                    </div>
                    <div className="completed-services__text-wrapper block">
                      <div className="completed-services__text order">
                        Заказ № {item.orderNumber}
                      </div>
                      <div className="completed-services__text text">
                        - Дата Уборки {`${day} ${month} ${hours}:${minutes}`}
                      </div>
                    </div>
                    <div className="completed-services__text-wrapper buttons">
                      <div
                        onClick={() => handleOpenModal(true, item)}
                        className="completed-services__cancel-button">
                        Изменить
                      </div>
                      <div
                        onClick={() =>
                          handleCancelOrder({
                            id: item._id,
                            orderNumber: item.orderNumber,
                          })
                        }
                        className="completed-services__cancel-button button-left">
                        Отменить уборку
                      </div>
                    </div>
                  </div>
                  <div className="text-price">{item.price} ₽</div>
                  {isExpanded && (
                    <span className="completed-services__item-span">
                      <div>
                        {item.whatPurpose && (
                          <div className="completed-services__text">
                            Объект - <span>{item.whatPurpose}</span>
                          </div>
                        )}

                        <div className="completed-services__text">
                          Количество комнат - <span>{item.room_count}</span>
                        </div>

                        <div className="completed-services__text">
                          Количество сан/узлов -{" "}
                          <span>{item.bathroom_count}</span>
                        </div>

                        <div>
                          <strong className="order">
                            Дополнительный сервис:
                          </strong>
                          <div className="completed-services__text">
                            {item.additional_services.map((service, idx) => (
                              <div key={idx}>
                                <div className="completed-services__text">
                                  <span>
                                    {service.name} [{service.count}] ={" "}
                                    {service.price} ₽
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="completed-services__text">
                          Адрес: <span>{item.address}</span>
                        </div>
                        {item.numberOfFloors && (
                          <div className="completed-services__text">
                            Количество этажей:{" "}
                            <span>{item.numberOfFloors}</span>
                          </div>
                        )}
                        {"elevator" in item && (
                          <div className="completed-services__text">
                            Лифт: <span>{item.elevator ? "Да" : "Нет"}</span>
                          </div>
                        )}
                        <div className="completed-services__text">
                          Домофон: <span>{item.intercom}</span>
                        </div>
                        <div className="completed-services__text">
                          Комментарий: <span>{item.comment}</span>
                        </div>

                        {item.cleaner && (
                          <div className="mt-4">
                            <strong className="order">
                              Информация о клинере:
                            </strong>
                            <div className="completed-services__text">
                              Имя: <span>{item.cleaner.name}</span>
                            </div>
                            {item.cleaner.phone_number &&
                              item.cleaner.phone_number !== "no-phone" && (
                                <div className="completed-services__text">
                                  Телефон:{" "}
                                  <span>{item.cleaner.phone_number}</span>
                                </div>
                              )}
                          </div>
                        )}
                      </div>

                      <div>
                        <div className="completed-services__text">
                          Формат оплаты: <span>{item.payment_type}</span>
                        </div>
                        <div className="completed-services__text">
                          Сумма заказа: <span>{item.price}</span>
                        </div>
                        <div className="completed-services__text">
                          Списано бонусов: <span>{item.bonusAmount}</span>
                        </div>
                        <div className="completed-services__text">
                          Итого сумма заказа:{" "}
                          <span>{item.price - item.bonusAmount}</span>
                        </div>
                      </div>
                    </span>
                  )}
                </li>
              );
            })
        )}
      </ul>
      {modal && (
        <ChangeOrder
          handleOpenModal={handleOpenModal}
          handleCloseModal={handleCloseModal}
          data={dataChange}
        />
      )}
      {cancelModal && (
        <CancelOrder
          handleCloseModal={() => setCancelModal(false)}
          orderId={cancelId.id}
          orderNumber={cancelId.orderNumber}
        />
      )}
    </section>
  );
});

export default MyOrders;
